import { render, staticRenderFns } from "./CompanyDetailView.vue?vue&type=template&id=46948f38&"
import script from "./CompanyDetailView.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports